import React from 'react';
import { RoleActiveTools } from '@/components/ai/RoleActiveTools';

/**
 * Prospect Active Tools Page
 * Shows the prospect's (athlete's) active AI tools from the marketplace
 */
export default function ProspectAiTools() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-6">
      <RoleActiveTools
        role="prospect"
        title="Your Tools"
        description="Launch your AI tools for highlights and profile building, and SmartBlock trackers for training efficiency and performance growth."
        marketplacePath="/portal/prospect/ai-marketplace"
        trackerBasePath="/portal/prospect/tracker"
        showComingSoon={true}
      />
    </div>
  );
}
